import { forwardRef, useImperativeHandle, useState } from 'react';
import { MaintenanceOperationTypeLabels } from '../../../shared/types/maintenanceOperation.ts';
import { LinkButton } from '../../components/linkButton.tsx';
import { MaintenanceOperation } from '../../types/sharedTypeImpl.ts';
import { formatDatetime } from '../../utils/fieldFormats.ts';
import { trpc } from '../../utils/trpc/trpc.ts';
import { MaintenanceOperationDialog } from './maintenanceOperationDialog.tsx';

interface DialogState {
    operationUnderEdit: MaintenanceOperation | null;
}


export interface MaintenanceLogTableRef {
    onAddOperationClicked: () => void;
}

interface Props {
    equipment: string,
    style?: React.CSSProperties,
}

export const MaintenanceLogTable = forwardRef<MaintenanceLogTableRef, Props>(({
    equipment,
    style,
}, ref) => {
    const [dialogState, setDialogState] = useState<DialogState | null>(null);//If not null, then dialog is open

    const { data: maintenanceOperations, isLoading, error, refetch } = trpc.maintenanceOperations.get.useQuery({
        equipment,
        sort: { time: -1 },
    });


    useImperativeHandle(ref, () => ({
        onAddOperationClicked: () => setDialogState({ operationUnderEdit: null }),
    }));


    return <>
        {isLoading && <p>Loading...</p>}
        {error && <p>Error retrieving data</p>}
        {maintenanceOperations &&
            <table style={style}>
                <thead>
                    <tr>
                        <th>Operation type</th>
                        <th>Comment</th>
                        <th style={{ minWidth: '150px' }}>Date / time</th>
                        <th>Operator</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {maintenanceOperations.map(operation => (
                        <tr key={operation._id}>
                            <td>{
                                operation.operationType
                                    ? MaintenanceOperationTypeLabels[operation.operationType]
                                    : ''
                            }</td>
                            <td>{operation.comment}</td>
                            <td>{formatDatetime(operation.time)}</td>
                            <td>{operation.operator?.toUpperCase()}</td>
                            <td>
                                <LinkButton
                                    onClick={() => setDialogState({ operationUnderEdit: operation })}
                                    content='Edit'
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        }

        {dialogState &&
            <MaintenanceOperationDialog
                equipment={equipment}
                operationUnderEdit={dialogState.operationUnderEdit ?? undefined}
                onOperationSaved={refetch}
                onClose={() => setDialogState(null)}
            />
        }
    </>
});
